import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import bemCnFast from '@webteam/bem-cn-fast';
import { withTheme } from '@webteam/ui-contexts';
import { CloseIcon } from '@webteam/icons';
import localNames from './index.pcss.js';

var bemCn = bemCnFast('wt-tag', localNames);

function isRemovableTag(isRemovable, size) {
  var _context;

  return isRemovable && _includesInstanceProperty(_context = ['xs', 's']).call(_context, size);
}

var Tag = React.forwardRef(function Tag(_ref, ref) {
  var className = _ref.className,
      isRemovable = _ref.isRemovable,
      isClickable = _ref.isClickable,
      disabled = _ref.disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      theme = _ref.theme,
      _ref$htmlTag = _ref.htmlTag,
      HtmlTag = _ref$htmlTag === void 0 ? 'span' : _ref$htmlTag,
      children = _ref.children,
      onRemoveClick = _ref.onRemoveClick,
      restProps = _objectWithoutProperties(_ref, ["className", "isRemovable", "isClickable", "disabled", "size", "theme", "htmlTag", "children", "onRemoveClick"]);

  var removable = isRemovableTag(isRemovable, size);
  return React.createElement(HtmlTag, _extends({}, restProps, {
    disabled: disabled,
    className: cn(bemCn({
      size: size,
      theme: theme,
      disabled: disabled,
      removable: removable,
      clickable: HtmlTag === 'a' || !!restProps.onClick || isClickable
    }), className),
    "data-test": "tag",
    ref: ref
  }), !removable ? children : React.createElement(React.Fragment, null, React.createElement("span", {
    className: bemCn('content')
  }, children), React.createElement(CloseIcon, {
    className: bemCn('close'),
    size: size,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (onRemoveClick) onRemoveClick();
    }
  })));
});
Tag.propTypes = {
  isRemovable: PropTypes.bool,
  isClickable: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 's', 'm']),
  theme: PropTypes.oneOf(['dark', 'light']),
  htmlTag: PropTypes.string,
  onRemoveClick: PropTypes.func
};
var tag = withTheme(Tag);

export { Tag, tag as default };
